/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import api from '@/lib/api';

/** Catalogo piani + stato abbonamento della clinica corrente (admin). */
export const getAiBillingPlans = async () => (await api.get('/ai-billing/plans')).data;

/** Avvia il checkout Stripe (subscription) per il tier richiesto. Ritorna { checkout_url, session_id }. */
export const startAiPlanCheckout = async (planTier) =>
  (await api.post('/ai-billing/checkout', { plan_tier: planTier, origin_url: window.location.origin })).data;

/** Stato della sessione dopo il redirect (polling). */
export const getAiCheckoutStatus = async (sessionId) => (await api.get(`/ai-billing/status/${encodeURIComponent(sessionId)}`)).data;

/** Stripe Customer Portal (fatture, metodo di pagamento, cancellazione). */
export const openAiBillingPortal = async () =>
  (await api.post('/ai-billing/portal', { origin_url: window.location.origin })).data;

/** Scarica il CSV di fatturazione (riepilogo per clinica, o dettaglio se clinicId). */
export const downloadAiUsageCsv = async (month, clinicId) => {
  const res = await api.get('/admin/ai-usage/export.csv', { params: { month, ...(clinicId ? { clinic_id: clinicId } : {}) }, responseType: 'blob' });
  const cd = res.headers?.['content-disposition'] || '';
  const name = /filename="([^"]+)"/.exec(cd)?.[1] || `sanitanexus_ai_${clinicId ? `dettaglio_${clinicId}_` : 'consumo_'}${month}.csv`;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url; a.download = name; a.rel = 'noopener';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  return name;
};

export const formatEur = (v) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Number(v) || 0);

/** Diagnostica Stripe sicura (admin): nessun segreto nella risposta. scope: 'platform' | 'clinic' | 'all' */
export const runStripeDiagnostics = async (scope = 'platform') => (await api.get('/admin/stripe/diagnostics', { params: { scope } })).data;
